export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_06.b5823cb2.jpg";